export type QueryData = {
    currentQueryString: string;
    // folderId is passed in either folderId, or constants from: packages\shared\lib\models\leftNav.ts
    folderId: string;
    // Internal folder Id passed to search backend
    internalFolderId: string;
    isAllFolder: boolean;
    source: QuerySource;
};

export const createFederatedSearchQueryData = (
    querystring: string,
    rootFolderId: string
): QueryData => ({
    currentQueryString: querystring,
    folderId: rootFolderId,
    internalFolderId: rootFolderId,
    isAllFolder: true,
    source: QuerySource.LegacyFederatedSearch,
});

export const enum QuerySource {
    Folder = 1,
    Directory,
    Favorites,
    RecipientCacheSuggestions,
    LegacyFederatedSearch,
    Groups,
}
